import PurchaseFailedModal from './PurchaseFailedModal';

export default PurchaseFailedModal;
